/* eslint-disable */
import { LIGHT_MODE_CHART_1, DARK_MODE_CHART_1 } from "utils/constant";
import { ReferenceArea } from "recharts";

export default function mappingTrimAreaX(coords) {
  const mode = document.body.dataset.theme;

  const trimAreaColour =
    mode === "light" ? LIGHT_MODE_CHART_1 : DARK_MODE_CHART_1;

  return (
    <ReferenceArea
      x1={coords[0]}
      x2={coords[1]}
      fill={trimAreaColour}
      opacity={0.2}
    />
  );
}
